import { COVERGO_SAAS_DEV, COVERGO_ASIA_PRE_PROD, COVERGO_AXATH_UAT, COVERGO_AXATH_PROD } from "../consts.js"

export const axaTh = {
	"axath-uat-studio.quote.hk": {
		appConfig: {
			tenantId: "axaTh_uat",
			appId: "admin_portal",
		},
		envConfig: COVERGO_ASIA_PRE_PROD
	}, // not in use
	"axath-demo-studio.quote.hk": {
		appConfig: {
			tenantId: "axaTh_uat",
			appId: "admin_portal",
		},
		envConfig: COVERGO_SAAS_DEV,
	},
	"axath-test-studio.quote.hk": {
		appConfig: {
			tenantId: "axaTh_test",
			appId: "admin_portal",
		},
		envConfig: COVERGO_SAAS_DEV,
	},
	"axath-prod-studio.quote.hk": {
		appConfig: {
			tenantId: "axaTh_prod",
			appId: "admin_portal",
		},
		envConfig: COVERGO_AXATH_PROD,
	},
	"axath-studio-pre.prod.axath.asia.covergo.net": {
		appConfig: {
			tenantId: "axaTh_prod",
			appId: "admin_portal",
		},
		envConfig: COVERGO_AXATH_PROD,
	},
	"axath-migration-studio.quote.hk": {
		appConfig: {
			tenantId: "axaTh_migration",
			appId: "admin_portal",
		},
		envConfig: COVERGO_SAAS_DEV,
	}, // not in use
	"axath-studio.preprod.asia.covergo.cloud": {
		appConfig: {
			tenantId: "axaTh_preprod",
			appId: "admin_portal",
		},
		envConfig: COVERGO_ASIA_PRE_PROD,
	},
	"axath-studio.uat.axath.asia.covergo.net": {
		appConfig: {
			tenantId: "axaTh_uatx",
			appId: "admin_portal",
		},
		envConfig: COVERGO_AXATH_UAT,
	},
}
